import { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Select, MenuItem } from "@material-ui/core";

const VehicleSelect = ({ vehicles, onSelect, onClose }) => {
  const [tempVehicleId, setTempVehicleId] = useState("");

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Please select a vehicle</DialogTitle>

      <DialogContent>
        <Select
          fullWidth
          value={tempVehicleId}
          onChange={(e) => setTempVehicleId(e.target.value)}
        >
          {vehicles.map((v) => (
            <MenuItem key={v.id} value={v.vehicleId}>
              {v.vin}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          disabled={!tempVehicleId}
          color="primary"
          onClick={() => onSelect(tempVehicleId)}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VehicleSelect;
